<template>
  <div class="wrapper">
    <div
      class="columns is-full-height is-mobile is-3-moobile is-vcentered is-centered has-padding-5-mobile is-gapless"
    >
      <div class="column is-full-mobile">
        <div class="flex-column align-items-center">
            <div>
            <p class="is-size-4 has-text-weight-semibold has-margin-top-20 has-text-white"> <b-icon icon="file-document-edit-outline"
                ></b-icon> <span class="has-padding-left-20">Apply to ship Dangerous Goods</span></p>
            <p class="is-size-4 has-text-weight-semibold has-margin-top-20 has-text-white"> <b-icon icon="find-replace"></b-icon> <span class="has-padding-left-20">Monitor Your Application</span></p>
            <p class="is-size-4 has-text-weight-semibold has-margin-top-20 has-text-white"> <b-icon icon="account-multiple-outline"></b-icon><span class="has-padding-left-20">Interact with NIMASA</span></p>
            </div>
        </div>
      </div>
      <div class="column is-full-height has-background-skyblue is-full-mobile flex-column align-items-center">
        <login-card class="has-padding-top-30"/>
        <div class="is-centered is-center flex-column align-center align-items-center">
           <p class="subtitle is-centered align-center">Sign Up as a shipper</p> 
           <b-button @click="signup" type="is-success"> Sign Up </b-button>
        </div>
        <img class="has-padding-top-30 image is-128x128" src="../../../assets/1x/shipping-cargo.png" alt="hudson trident logo">
      </div>
    </div>
    <div class="bottom-logos has-background-green">
      <img class="has-default-logo--style has-background-white" src="../../../assets/nimasa-logo.png" alt="hudson trident logo">
        <img class="has-default-logo--style" src="https://nimasa.gov.ng/wp-content/uploads/2019/09/2000px-Coat_of_arms_of_Nigeria.svg.png" alt="coat of arms">
      
    </div>
  </div>
</template>

<script>
import LoginCard from "@/modules/rootModule/components/LoginCard";
import SignUpCard from "@/modules/rootModule/components/SignupShipperCard"

export default {
  name: "LoginPage",
  components: { LoginCard, SignUpCard },
  methods: {
      signup(){
      this.$modal.open({
        parent: this,
        component: SignUpCard,
        scroll:"keep",
        hasModalCard: true,
      });
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100% !important;
}
.wrapper {
  background: linear-gradient(
      287deg,
      rgba(1, 71, 112, 0.5) 0%,
      rgba(1, 118, 172, 0.76) 100%
    ),
    url("../../../assets/ship-bg.jpg");
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.bottom-logos {
    position: absolute;
    bottom: 0;
  background: white;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  padding: .3em;
}

.has-background-skyblue {
  background: #e1f6ff !important;
}
.image {
  margin: 0 auto;
}
</style>

